import React from 'react';
import { Link } from 'react-router-dom';

interface BottomNavigationProps {
  active: 'tasks' | 'home' | 'swap';
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({ active }) => {
  return (
    <div className="flex justify-around border-t border-blue-700 py-2 pt-4">
      <Link to="/tasks" className={`flex flex-col items-center ${active === 'tasks' ? 'text-white font-bold' : 'text-gray-400'}`}>
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
        <span className="text-xs">Tasks</span>
      </Link>
      <Link to="/" className={`flex flex-col items-center ${active === 'home' ? 'text-white font-bold' : 'text-gray-400'}`}>
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
        <span className="text-xs">Home</span>
      </Link>
      <Link to="/swap" className={`flex flex-col items-center ${active === 'swap' ? 'text-white font-bold' : 'text-gray-400'}`}>
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
        </svg>
        <span className="text-xs">Swap</span>
      </Link>
    </div>
  );
};

export default BottomNavigation;